var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.56689 15.1035C3.21826 15.4521 3.20166 16.0747 3.5752 16.4399C3.94043 16.8052 4.56299 16.7969 4.91162 16.4482L9.9917 11.3599L15.0801 16.4482C15.437 16.8052 16.0513 16.8052 16.4165 16.4399C16.7734 16.0664 16.7817 15.4605 16.4165 15.1035L11.3364 10.0151L16.4165 4.93506C16.7817 4.57813 16.7817 3.96387 16.4165 3.59863C16.043 3.2417 15.437 3.2334 15.0801 3.59033L9.9917 8.67871L4.91162 3.59033C4.56299 3.2417 3.93213 3.2251 3.5752 3.59863C3.20996 3.96387 3.21826 4.58643 3.56689 4.93506L8.65527 10.0151L3.56689 15.1035Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.c78744ae.svg";
export { ForwardRef as ReactComponent };